<template>
<Box @close="close({})" width="800px" v-if="producto">
    <template #top>Modificar Producto</template>
    <template #center>
        <div class="nj-card">
            <div class="nj-grid">
                <InputText label="Producto" v-model="producto.prv_nombre"></InputText>
                <InputSelect v-model="producto.cat_id" :source="categorias" label="Categoria" :labelFunction="labelCategoria" itemKey="cat_id"
                    itemFilter="cat_nombre" itemValue="cat_id" @selectItem="obtenerTiposProducto"></InputSelect>
                <InputSelect v-model="producto.tip_id" :source="tipos_producto" label="Tipos producto" :labelFunction="labelTipoProducto" itemKey="tip_id" itemValue="tip_id" itemFilter="tip_nombre">
                </InputSelect>
                <InputSelect v-model="producto.mar_id" :source="marcas" label="Marcas" :labelFunction="labelMarca" itemKey="mar_id" itemValue="mar_id" itemFilter="mar_nombre"></InputSelect>
                <InputSelect v-model="producto.unm_id" :source="unidades_medida" label="Unidad" :labelFunction="labelUnidad" itemKey="unm_id" itemValue="unm_id" itemFilter="unm_descripcion">
                </InputSelect>
                <InputSelect v-model="producto.prv_item" :source="activation_options" label="Agregar número serie" :labelFunction="(item) => item.name" itemKey="id" itemValue="id"
                    itemFilter="name"></InputSelect>
                <InputSelect v-model="producto.prv_reposicion" label="Reposición" :source="activation_options" :labelFunction="(item) => item.name" itemKey="id" itemValue="id" itemFilter="name">
                </InputSelect>
                <InputSelect v-model="producto.prv_retornable" label="Retornable" :source="activation_options" :labelFunction="(item) => item.name" itemKey="id" itemValue="id" itemFilter="name">
                </InputSelect>
                <InputText v-model="producto.prv_retorno_estimado" label="Retorno estimado" :disabled="producto.prv_retornable == 0"></InputText>
            </div>
        </div>
    </template>
    <template #bottom>
        <Button icon="save" label="Modificar" @click="modificar()"></Button>
    </template>
</Box>
</template>

<script>
import { ActivationEnum } from "../../constants"
import { OpcionesService, ProductoService, ResponseStatus } from "../../services"
import Toast from "../../util/toast"
import { Box, Button, InputSearch, InputSelect, InputText } from "../components"

export default {
    name: "ModificarProducto",
    props: {
        prv_id: {
            type: Number,
            default: null
        }
    },
    components: {
        Box,
        InputText,
        InputSearch,
        InputSelect,
        Button,
    },
    data() {
        return {
            categorias: [],
            tipos_producto: [],
            marcas: [],
            unidades_medida: [],
            activation_options: [],
            producto: {
                prv_id: null,
                prv_nombre: null,
                prv_estado: null,
                cat_id: null,
                tip_id: null,
                mar_id: null,
                unm_id: null,
                prv_item: null,
            },
            cat_id: null
        }
    },
    computed: {},
    methods: {
        labelCategoria(item) {
            return item.cat_nombre
        },
        labelTipoProducto(item) {
            return item.tip_nombre
        },
        labelMarca(item) {
            return item.mar_nombre
        },
        labelUnidad(item) {
            return item.unm_descripcion
        },
        obtenerTiposProducto(categoria) {
            if (categoria) {
                OpcionesService
                    .getOpciones({
                        tipo_producto: {
                            cat_id: categoria.cat_id
                        }
                    })
                    .then(response => {
                        if (ResponseStatus.isSuccess(response)) {
                            this.tipos_producto = response.data.tipos_producto
                        }
                        else {
                            Toast.error(response.message)
                        }
                    })
                    .catch(error => {
                        Toast.error(error)
                    })
            }
        },
        modificar() {
            ProductoService
                .modificar({
                    producto: this.producto,
                })
                .then((response) => {
                    if (ResponseStatus.isSuccess(response)) {
                        Toast.success(response.message)
                        this.close({
                            renderizar: true
                        })
                    } else {
                        Toast.error(response.message)
                    }
                })
                .catch((error) => {
                    Toast.error(error)
                })
        },
        close({
            componente = "modificar",
            activar = false,
            renderizar
        }) {
            this.$emit("close", {
                componente,
                activar,
                renderizar,
            })
        },
        obtenerDatos() {
            // * obteniendo los datos del producto-vendor
            ProductoService
                .obtener({
                    producto: {
                        prv_id: this.prv_id
                    }
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.producto = response.data
                        this.obtenerOpciones()
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
        obtenerOpciones() {
            OpcionesService
                .getOpciones({
                    categoria: {},
                    marca: {},
                    unidad_medida: {},
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.categorias = response.data.categorias
                        this.marcas = response.data.marcas
                        this.unidades_medida = response.data.unidades_medida
                        this.activation_options = ActivationEnum.getAll()
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        }
    },
    mounted() {
        this.obtenerDatos()
    }
}
</script>

<style scoped></style>